import { Version } from '@angular/core';
export const FUSE_VERSION = new Version('14.1.1').full;
